import { Slider } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';

import style from './CreditSlider.module.scss';

interface AntdCreditSliderProps {
  options: number[];
  defaultValue: number;
  onChange?: (value: number) => void;
}

const CreditSlider: React.FC<AntdCreditSliderProps> = ({
  options,
  defaultValue,
  onChange,
}) => {
  const total = options.length - 1;

  // 根据 realValue 找百分比
  const realValueToPercent = (val: number) => {
    const idx = options.findIndex((item) => item === val);
    if (idx === -1) return 0;
    return (idx / total) * 100;
  };

  const [percent, setPercent] = useState(realValueToPercent(defaultValue));

  useEffect(() => {
    setPercent(realValueToPercent(defaultValue));
  }, [defaultValue]);

  const marks = useMemo(() => {
    return options
      .sort((a, b) => a - b)
      .reduce((acc: any, item, index) => {
        const p = Math.round((index / total) * 100);
        acc[p] = item;
        return acc;
      }, {});
  }, [options, total]);

  const handleChange = (p: number) => {
    setPercent(p);
    const idx = Math.round((p / 100) * total);
    const realVal = options[idx];
    onChange?.(realVal);
  };

  return (
    <div className="w-full flex justify-center">
      <Slider
        classNames={{
          root: style['CreditSlider'],
        }}
        marks={marks}
        min={0}
        max={100}
        step={null}
        dots
        value={percent}
        onChange={handleChange}
        keyboard={false}
        tooltip={{ open: false }}
      />
    </div>
  );
};

export default CreditSlider;
